import React from 'react';
import './Footer.css'
import Instagram from '../../assets/image/icon-ig.png'
import Facebook from '../../assets/image/icon-fb.png'

const Footer = () => {
  return (
    <>
      {/* <div className='container-footer'> */}
      <footer className='flex justify-center items-center flex-col lg:mt-24 md:mt-24 sm:mt-10 w-full'>
        <div className='divider-footer-bottom'></div>
        <div className='box-footer flex justify-center items-center flex-col w-full'>
          <p className='lg:text-3xl sm:text-xl'>
            @Copyright Moendoe 2023 - Jakarta Timur
          </p>
          <div className='box-img-footer'>
            {/* <img src={Instagram} alt="" srcset="" />
                <img src={Facebook} alt="" srcset="" /> */}
          </div>
        </div>
      </footer>
      {/* </div> */}
    </>
  );
}

export default Footer
